import ApiDefinition from "./ApiDefinition";


const AIApi = new ApiDefinition({
    chat: {
        url: () => `mcp/uwe`,
        method: 'post',
        body: data => data
    },
    // Streaming chat (SSE): POST /start (authed) mints a short-lived sessionId;
    // the caller then opens an EventSource on ai/chatStream/listen/{sessionId}.
    // Returns the raw body `{ sessionId }` (not wrapped in the {data} envelope),
    // so bypass the default `response.data` extraction.
    chatStreamStart: {
        url: () => `ai/chatStream/start`,
        method: 'post',
        body: data => data,
        checkErrors: false,
        dataPath: response => response,
    },
    generateWorkflow: {
        url: 'ai/generateWorkflow/',
        method: 'post',
        body: data => data
    },
    generateForm: {
        url: 'ai/generateForm/',
        method: 'post',
        body: data => data
    }
})

export default AIApi;